export const STYLE_COLUMN = {
  TEXT: 'Text',
  BUTTON_LIST: 'buttonList'
}
